import React, {useState, useEffect} from "react";
import {Link} from '@mui/material/';
import axios from "axios";
import {useSearchParams} from "react-router-dom";
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";
import {Button, List, ListItem, Typography, Card, Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,} from "@mui/material";
import TextInput from "../components/TextInput";
import dayjs from "dayjs";

export const DialogBox = ({open, handleClose, cancelSession, mentor}) => {
    return (
        <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
        >
            <DialogTitle className='center-align'>
                {"Cancel Session"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
              <span className='col-center'>
                <span>Cancel session with {mentor}?</span>
                <br/>
              </span>
                </DialogContentText>
            </DialogContent>
            <DialogActions className='center-align'>
                <Button variant='outlined' onClick={handleClose}>Cancel</Button>
                <Button variant='outlined' onClick={cancelSession} autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const Sessions = () => {
    const [message, setMessage] = useState("")
    const [error, setError] = useState('')
    const [sessions, setSessions] = useState(false)
    const [open, setOpen] = useState(false)
    const [selectedMeeting, setSelectedMeeting] = useState(false)
    const [selectedMentor, setSelectedMentor] = useState(false)
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (window.location.href.split('?message=')[1]) {
            if (window.location.href.split('?message=')[1] === 'success') {
                setMessage("The session was canceled successfully.")
            }
        }
        axios.post(constants.serverURL + "getFutureSessions", [],      {
            withCredentials: true,
        }).then(response => {
            setSessions(response.data)
        }).catch((error) => {
            console.log('basdf')
            if (error.request.responseText === 'expired token') {
                window.location.href = constants.websiteURL + '#/refreshToken?redirect=sessions'
            } else {
                setError(error.request.responseText)
                window.location.href = constants.websiteURL + "#/"
            }
        })
    }, [])
    const cancelSession = () => {
        axios.post(constants.serverURL + "cancelSession", {meetingId: selectedMeeting},      {
            withCredentials: true,
        }).then(response => {
            window.location.href = constants.websiteURL + '#/sessions?message=success'
            window.location.reload()
        }).catch((error) => {
            console.log(error)
            if (error.request.responseText === 'expired token') {
                window.location.href = constants.websiteURL + '#/refreshToken?redirect=sessions'
            } else {
                setError(error.request.responseText)
                window.location.href = constants.websiteURL + "#/"
            }
        })
    };
    const handleClickOpen = (meetingId, mentorName) => {
        setOpen(true);
        setSelectedMeeting(meetingId)
        setSelectedMentor(mentorName)
    };
    console.log(sessions.length)

    return (
        <div>
            <MenuAppBar title="" signedIn={true}></MenuAppBar>
            <Typography align='center' sx={{fontSize: '36px'}}>Mentor Sessions</Typography>
            <List>
                {
                    error &&
                    <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                        <Typography className="font-16 error-message">{error}</Typography>
                    </ListItem>
                }
                {
                    message &&
                    <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                        <Typography className="font-16">{message}</Typography>
                    </ListItem>
                }
                <div>
                    <div>
                        {sessions && sessions.map(session => (
                            <Grid item xs={12} sm={6} md={4} lg={3} className="center-align" key={session.meetingId}>
                                <Card id={session.meetingId} className="mentor-card">
                                    <p className="center-align font-18">{session.mentorName}</p>
                                    <img
                                        src={constants.mentorImageBucketURL + session.mentorId + '.png'}
                                        alt="Not Found"
                                        className="circle"
                                    />
                                    <p className="center-align font-14">
                                        {new Date(session.startTime).toLocaleDateString("en-US", {weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric'})}
                                        -
                                        {new Date(session.endTime).toLocaleTimeString("en-US", {hour: 'numeric', hour12: true, minute: 'numeric'})}
                                    </p>
                                    <Button href={session.meetingLink} className="button" variant="outlined">
                                        Go to the meeting
                                    </Button>
                                    <div className="button-group center-align">
                                        <Button className="m-form-button" variant="outlined" onClick={() => handleClickOpen(session.meetingId, session.mentorName)}>Cancel this meeting</Button>
                                    </div>
                                </Card>
                            </Grid>
                        ))}
                    </div>
                    <div>
                        {sessions.length === 0 &&
                            <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                            <Typography className="font-16">You don't have any sessions.</Typography>
                            </ListItem>
                        }
                    </div>
                    <DialogBox
                        open={open}
                        handleClose={handleClose}
                        cancelSession={cancelSession}
                        mentor = {selectedMentor}
                    />
                </div>
            </List>
        </div>
    );
};

export default Sessions;